<template>
    <div>
        <v-checkbox  
        v-model="value"
        @change="handleUpdate"
        label="Use Text Area"/>
    </div>
</template>
<script>
export default {
    props: ['field'],
    data: function() {
        return {
            value: false,
        };
    },
    methods: {
        handleUpdate(){
            this.$emit('updateFieldMeta', 'isTextArea', this.value);
        }
    },
    mounted: function() {
        this.value = this.field.metadata ? this.field.metadata.isTextArea : false;
    }
}
</script>
